import { Link, NavLink } from 'react-router';
import styled from 'styled-components';

export const FooterStyled = styled.footer`
  padding: 50px 100px 24px 100px;
  background: ${({ theme }) => theme.black};

  img {
    width: 220px;
  }

  @media (max-width: 1000px) {
    img {
      width: 150px;
    }
  }
`;

export const FooterText = styled.p`
  font-family: Outfit;
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.white};
`;

export const FooterLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.white};
`;
